import { render, staticRenderFns } from "./VacanciesAssign.vue?vue&type=template&id=82f75dd6&"
import script from "./VacanciesAssign.vue?vue&type=script&lang=js&"
export * from "./VacanciesAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports